<div class="relative" tabindex="0">
    <a
        [routerLink]="type === 'salesperson' ? '/profile/change-password' : '/user-profile/change-password'"
        class="bg-primary rounded-full h-9 w-9 grid place-content-center cursor-pointer hover:bg-primary/75 border-primary border transition-colors"
    >
        <app-icon name="bi:person" class="icon-5 icon-white"></app-icon>
    </a>
</div>
